export const CLIENT = 'CLIENT';
export const DESIGNER = 'DESIGNER';
export const CONSULTANT = 'CONSULTANT';
export const FABRICATOR = 'FABRICATOR';
